module.exports = __webpack_public_path__ + "img/invite_bkg.7a048caa.png";